<template>
    <div>
        <div v-if="isModalShow" class="dim-overlay" @click="closeModal"></div>
        <div id="easyAddressSearch" class="modal" :style="{ display: isModalShow ? 'block' : 'none' }" tabindex="-1"
             role="dialog" aria-labelledby="addressModalCenterTitle" :aria-hidden="!isModalShow"
             @click.self="closeModal">

            <div class="modal-dialog modal-dialog-centered" role="document">

                <div class="modal-content" style="max-height: 90vh;">

                    <div class="modal-header" style="border: none;">
                        <button type="button" class="close" @click="closeModal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <form class="-js-adress-form" @submit.prevent="searchSubmit">
                            <input type="hidden" name="CallInfo" :value="callInfo"/>
                            <input type="hidden" name="CallIdx" :value="callIdx"/>

                            <div v-if="showDefault">
                                <h2 v-if="hall === 'wedding'"><strong>결혼식장</strong>을 검색해 주세요.</h2>
                                <h2 v-else-if="hall === 'funeral'"><strong>장례식장</strong>을 검색해 주세요.</h2>
                                <h2 v-else><strong>주소</strong>를 검색해 주세요.</h2>

                                <div class="row">
                                    <div class="col">
                                        <div class="input-bottom">
                                            <input
                                                style="width: 75%; display: inline-block; border: none;"
                                                class="-js-address-input form-control input-bottom"
                                                type="text"
                                                v-model="address"
                                                autocomplete="off"

                                                :placeholder="placeholderText"
                                                @input="toggleClearButton"
                                            />
                                            <button
                                                v-if="showClearButton"
                                                @click="clearInput"
                                                type="button"
                                                class="-js-address-search-clear-button searchClear-wrap">
                                                <span class="searchClear"></span>
                                            </button>
                                            <button title="검색" class="search-icon" type="submit"></button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="showDeliveryCharge">
                                <h2>
                                    <strong>추가 배송비 안내</strong>
                                    <p class="info-text">해당 주소는 배송비 <span class="danger">{{ mwHelper.numberFormat(deliveryCharge)}}원</span>이 추가 됩니다.</p>
                                </h2>
                            </div>

                            <div v-if="this.hasReplacement">
                                <h2>
                                    <strong><span class="danger">반입 제한 대체</span> 상품 안내</strong>
                                </h2>
                            </div>

                            <div v-if="showDetailInput">
                                <h2><strong>상세주소</strong>를 입력해 주세요.</h2>
                            </div>

                            <div class="address-form">
                                <!-- 디폴트 -->
                                <div v-if="showTip && !loading && !results.length" class="-js-address-tip-div">
                                    <h4 class="font-size-18 mt-20-px"><b>Tip</b></h4>
                                    <p>아래와 같은 조합으로 검색을 하시면 더욱 정확한 결과가 검색됩니다.</p>
                                    <ul style="padding-left: 0;">
                                        <li>
                                            <p style="margin: 0;">지역명(동/리) + 예식장/장례식장명</p>
                                            <p style="color: #959595;">예) 여의도 예식장, 여의도 장례식장</p>
                                        </li>
                                        <li>
                                            <p style="margin: 0;">도로명 + 건물번호</p>
                                            <p style="color: #959595;">예) 판교역로 235, 제주 첨단로 242</p>
                                        </li>
                                        <li>
                                            <p style="margin: 0;">지역명(동/리) + 번지</p>
                                            <p style="color: #959595;">예) 삼평동 681, 제주 영평동 2181</p>
                                        </li>
                                        <li>
                                            <p style="margin: 0;">지역명(동/리) + 건물명(아파트명)</p>
                                            <p style="color: #959595;">예) 분당 주공, 연수동 주공3차</p>
                                        </li>
                                        <li>
                                            <p style="margin: 0;">사서함명 + 번호</p>
                                            <p style="color: #959595;">예) 분당우체국사서함 1~100</p>
                                        </li>
                                    </ul>
                                </div>

                                <!-- 검색했을시 -->
                                <div v-if="!loading && results.length" style="display: block;"
                                     class="-js-address-list-div address-form-list">
                                    <ul style="padding-left: 0;" class="-js-address-list-ul">
                                        <li v-for="(result, index) in results" :key="index">
                                            <p class="tit">
                                                {{ result.title || "" }} <span class="zipcode">({{ result.zipcode || "" }})</span>
                                            </p>
                                            <p v-if="result.roadAddress" class="doro">
                                                {{ result.roadAddress }} {{ result.addressDetail || "" }}
                                            </p>
                                            <p class="jibun">
                                                {{ result.jibunAddress }} {{ result.addressDetail || "" }}
                                            </p>
                                            <div class="box-btn">
                                                <button type="button" class="btn-line-point" @click="selectAddressAll(result)">선택</button>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                <!-- 검색 리스트 로딩 -->
                                <div v-if="loading" class="-js-address-loading-div">
                                    <div class="loadingBox">
                                        <div class="circle"></div>
                                    </div>
                                </div>

                                <!-- 검색결과 없을시 -->
                                <div v-if="!loading && !results.length && showEmptyMessage"
                                     class="-js-address-empty-div address-form-list-none">
                                    <div style="text-align: center;">
                                        <i class="n-icon02"></i>
                                        <span v-if="hall === 'wedding'">조회된 결혼식장이 없습니다.</span>
                                        <span v-else-if="hall === 'funeral'">조회된 장례식장이 없습니다.</span>
                                        <span v-else>조회된 결과가 없습니다.</span>
                                    </div>
                                </div>

                                <!-- 상세주소입력 -->
                                <div v-if="showDetailInput" class="-js-address-detail-div">
                                    <ul class="address-form-list">
                                        <li>
                                            <p class="tit">{{ tempAddressTit }} <span class="zipcode">({{ tempAddressZipcode }})</span></p>
                                            <p class="doro">{{ tempAddressDoro }}</p>
                                            <p class="jibun">{{ tempAddressJibun }}</p>
                                            <div class="box-btn">
                                                <button type="button" class="btn-line-point" @click="clearInput">변경</button>
                                            </div>
                                        </li>
                                    </ul>

                                    <div class="form-group mt-20-px">
                                        <div class="row">
                                            <div class=""
                                                 :class="{
                                                    'col-9 pr-0 mb-0': ['wedding', 'funeral'].includes(hall),
                                                    'col-12': !['wedding', 'funeral'].includes(hall)
                                                 }"
                                            >
                                                <input type="text" v-model="tempAddressDetail" :disabled="isDisabled" :placeholder="detailPlaceholderText"
                                                       class="-js-temp-address-detail form-control" autocomplete="off" title="상세주소">
                                            </div>
                                            <div class="col-3 mb-0" v-if="['wedding', 'funeral'].includes(hall)">
                                                <div class="custom-control custom-checkbox">
                                                    <input class="custom-control-input" type="checkbox" value="1" name="no2" id="no2" v-model="isDisabled">
                                                    <label class="custom-control-label" for="no2">모름</label>
                                                </div>
                                            </div>
                                            <div class="col-12 n-box" v-if="isDisabled">
                                                <span class="n-icon"></span>
                                                <span class="n-text">정확한 주소 파악을 위해 추후 주문자에게 개별 연락이 갈 수 있습니다.</span>
                                            </div>
                                        </div>

                                        <div class="row mt-20-px">
                                            <div class="col-12">
                                                <div class="textarea-wrap">
                                                    <textarea class="form-control"
                                                      name="order_delivery[memo]"
                                                      v-model="tempMemo"
                                                      placeholder="배송요청사항(100자 이내로 입력해 주세요)" title="배송요청사항"
                                                      @input="function (event) { tempMemo = mwHelper.removeEmojis(event.target.value) }"
                                                      maxlength="100"
                                                      cols="30" rows="1"></textarea>
                                                    <div class="count"><span class="current">{{ (tempMemo || '').length }}</span>/100</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <button @click="confirmAddress" class="-js-address-detail-button bt-btn" type="button">
                                        <span>확인</span>
                                    </button>
                                </div>

                                <div v-if="this.hasReplacement">
                                    <ul class="address-form-list">
                                        <li>
                                            <p class="tit">{{ tempAddressTit }} <span class="zipcode">({{ tempAddressZipcode }})</span></p>
                                            <p class="doro">{{ tempAddressDoro }}</p>
                                            <p class="jibun">{{ tempAddressJibun }}</p>
                                            <div class="box-btn">
                                                <button type="button" class="btn-line-point" @click="clearInput">변경</button>
                                            </div>
                                        </li>
                                    </ul>

                                    <div class="box-danger">
                                        <p class="tit">해당 주소는 <strong class="danger">아래 지정된 상품만</strong> 반입 가능합니다.</p>
                                        <p>실제 배송 상품은 배송지역에 따라<br />제품과 이미지가 다소 차이가 있을 수 있습니다.</p>
                                    </div>

                                    <div v-html="this.replacementProductHtml" class="replacement-box">
                                    </div>

                                    <button @click="confirmReplacement" class="-js-address-detail-button bt-btn"
                                            :class="hasReplacement && !replacementProductId ? 'disabled' : ''"
                                            type="button">
                                        <span>확인</span>
                                    </button>
                                </div>

                                <div v-if="showDeliveryCharge">
                                    <ul class="address-form-list">
                                        <li>
                                            <p class="tit">{{ tempAddressTit }} <span class="zipcode">({{ tempAddressZipcode }})</span></p>
                                            <p class="doro">{{ tempAddressDoro }}</p>
                                            <p class="jibun">{{ tempAddressJibun }}</p>
                                            <div class="box-btn">
                                                <button type="button" class="btn-line-point" @click="clearInput">변경</button>
                                            </div>
                                        </li>
                                    </ul>
                                    <button @click="confirmDelivery" class="-js-address-detail-button bt-btn" type="button">
                                        <span>확인</span>
                                    </button>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            callInfo: {
                type: String,
                default: "",
            },
            callIdx: {
                type: String,
                default: "",
            },
            carts: {
                type: Array,
                default: [],
            },
            hall: {
                type: String,
                default: "",
            },
            useAdditionalDeliveryFee: {
                type: String,
                default: "",
            }
        },
        data() {
            return {
                mwHelper: window.mwHelper,
                address: "", // 주소 입력창
                results: [], // 주소 검색결과
                loading: false,
                showTip: true,
                showDefault: true,          //기본
                showEmptyMessage: false,    // 검색 결과 없을시 메시지
                showClearButton: false,     // x 버튼 표시
                showDetailInput: false,     // 상세주소 입력 메시지
                showDeliveryCharge: false,  //추가 배송비 영역

                tempAddress: "", // 상세 주소
                tempAddressTit: "",     //선택된 타이틀
                tempAddressZipcode: "", // 우편번호
                tempAddressDoro: "",    //선택된 지번주소
                tempAddressJibun: "",   //선택된 지번주소
                tempAddressDetail: "",  // 상세 주소 입력
                tempMemo: "",           // 배송 요청사항

                deliveryCharge: 0,      // 배송비
                isModalShow: false,
                hasReplacement: false,  // 대체상품 영역
                replacementProductHtml: '',
                replacementTargetCartIds : [],
                replacementId: null,
                replacementProductId: null,
                isDisabled: false,                 //비활성화
            };
        },
        watch: {
            isDisabled(val) {
                if (val) {
                    this.tempAddressDetail = '';
                }
            }
        },
        computed: {
            placeholderText() {
                if (this.hall === 'wedding') return '결혼식장을 검색해 주세요.'
                if (this.hall === 'funeral') return '장례식장을 검색해 주세요.'
                return '주소를 검색해 주세요.'
            },
            detailPlaceholderText() {
                if (this.hall === 'wedding') return '예식홀 이름을 입력해 주세요.'
                if (this.hall === 'funeral') return '장례식장 호실을 입력해 주세요.'
                return '상세주소를 입력해 주세요.'
            },
        },
        methods: {
            openModal() {
                this.isModalShow = true;
                history.pushState({ __modal: true }, '');
            },
            closeModal() {
                this.isModalShow = false;
                this.resetState();

                if (history.state && history.state.__modal) {
                    history.back();
                }
            },
            toggleClearButton() {
                this.showClearButton = !!this.address;
            },
            clearInput() {
                this.address = "";
                this.results = [];
                this.showDefault = true;
                this.showTip = true;
                this.showEmptyMessage = false;
                this.showClearButton = false;
                this.showDetailInput = false;
                this.showDeliveryCharge = false;
                this.hasReplacement = false;
                this.tempAddressDetail = "";
                this.tempMemo = "";
            },
            searchSubmit() {
                this.results = [];
                this.loading = true;
                this.showDefault = true;
                this.showTip = false;
                this.showDetailInput = false;
                this.showEmptyMessage = false;
                axios
                    .post("/areas/search", {address: this.address, delivery_charge: "on", cart_ids: this.cartIds()})
                    .then((response) => {
                        if (response.data.code === 0) {
                            this.results = response.data.data.addressArray || [];
                            this.showEmptyMessage = this.results.length === 0;
                        }
                    })
                    .catch((error) => {
                        console.error("Error:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            resetSearchState() {
                this.results = [];
                this.showEmptyMessage = false;
                this.showTip = false;
                this.showDefault = false;
            },
            resetReplacement() {
                this.hasReplacement = false;
                this.replacementTargetCartIds = [];
                this.bindReplacementProductList(null);
            },
            updateDeliveryView() {
                if (this.useAdditionalDeliveryFee === 'Y'
                    && this.carts.some(cart => cart.product_json?.active_additional_delivery_fee === 'Y')
                    && this.deliveryCharge > 0) {
                    this.hasReplacement = false;
                    this.showDeliveryCharge = true;
                    this.showDetailInput = false;
                } else {
                    this.hasReplacement = false;
                    this.showDeliveryCharge = false;
                    this.showDetailInput = true;
                }
            },
            selectAddressAll(item) {
                // 주소 정보
                this.tempAddressTit = item.title || '';
                this.tempAddressZipcode = item.zipcode || '';
                this.tempAddressDoro = item.roadAddress || '';
                this.tempAddressJibun = item.jibunAddress || '';
                this.deliveryCharge = item.deliveryCharge || 0;

                // 대체상품 여부
                if (item.replacement !== undefined) {
                    this.hasReplacement = true;
                    this.replacementId = item.replacement.id;
                    this.replacementTargetCartIds = item.replacement.carts;
                    this.bindReplacementProductList(this.replacementId);

                    this.showDeliveryCharge = false;
                    this.showDetailInput = false;
                } else {
                    this.resetReplacement();
                    this.updateDeliveryView();
                }

                this.resetSearchState();
            },
            confirmReplacement() {
                if (this.hasReplacement && !this.replacementProductId) {
                    alert('대체 상품을 선택해주세요.');
                    return;
                }
                this.updateDeliveryView();
            },
            confirmDelivery() {
                this.showDetailInput = true;
                this.showDeliveryCharge = false;
            },
            confirmAddress() {
                const payload = {
                    address: this.tempAddressDoro || this.tempAddressJibun || "",
                    address_title: this.tempAddressTit || "",
                    address_detail: this.tempAddressDetail || "",
                    zipcode: this.tempAddressZipcode || "",
                    deliveryCharge: this.deliveryCharge || 0,
                    memo: this.tempMemo || "",
                    replacement: {
                        id : this.replacementId,
                        cartIds: this.replacementTargetCartIds,
                        replacementProductId: this.replacementProductId,
                    }
                };

                if (!payload.address) {
                    alert('주소는 필수 항목입니다.');
                    return ;
                }

                if (!payload.address_detail && !this.isDisabled) {
                    alert(this.detailPlaceholderText);
                    return ;
                }

                this.$emit('address-selected', payload);
                // 네이티브 앱 호출 (Flutter)
                try {
                    if (window.flutter_inappwebview) {
                        window.flutter_inappwebview.callHandler(
                            'handlerAddressData',
                            payload.address,
                            payload.address_detail,
                            payload.zipcode,
                            payload.deliveryCharge
                        ).then(result => {
                            // console.log('Flutter Result:', result);
                        });
                    }
                } catch (e) {
                    // console.error('Flutter 호출 실패:', e);
                }

                // 네이티브 앱 호출 (Android)
                try {
                    if (window.MyAndroid) {
                        window.MyAndroid.handlerAddressData(
                            payload.address,
                            payload.address_detail,
                            payload.zipcode,
                            payload.deliveryCharge
                        );
                    }
                } catch (e) {
                    // console.error('Android 호출 실패:', e);
                }

              this.closeModal();
            },
            bindCategories() {
                let categories = [];
                this.carts.forEach(function (item) {
                    item.product.product_categories.forEach(function (category) {
                        categories.push(category);
                    });
                });

                this.categories = categories;
            },
            cartIds() {
                let cartIds = [];
                this.carts.forEach(function (item) {
                    cartIds.push(item.id);
                });

                return cartIds;
            },
            bindReplacementProductList(replacementId) {
                let self = this;
                if (replacementId) {
                    axios
                        .get(`/products/easy-replacement/${replacementId}`,)
                        .then((response) => {
                            self.replacementProductHtml = response.data;
                        })
                        .catch((error) => {
                            console.error("Error:", error);
                        });
                } else {
                    self.replacementProductHtml = '';
                }
            },
            resetState() {
                this.address = "";
                this.results = [];
                this.showDefault = true;
                this.showTip = true;
                this.showClearButton = false;
                this.showEmptyMessage = false;
                this.showDetailInput = false;
                this.showDeliveryCharge = false;
                this.hasReplacement = false;
                this.tempAddress = "";
                this.tempAddressDetail = "";
                this.tempMemo = "";
                this.tempAddressZipcode = "";
                this.deliveryCharge = "on";
                this.replacementProductHtml = "";
                this.replacementProductId = null;
                this.replacementId = null;
                this.replacementTargetCartIds = [];
            },
        },
        mounted() {
            let self = this;
            this.bindCategories();

            document.addEventListener('click', function (e) {
                if (e.target && e.target.closest('.replacement-anchor')) {
                    e.preventDefault(); // a 태그 기본 이동 방지
                    const anchor = e.target.closest('.replacement-anchor');
                    const targetBtn = anchor.closest('.product').querySelector('.replacement-btn');
                    if (targetBtn) targetBtn.click();
                }

                if (e.target && e.target.closest('.replacement-btn')) {
                    const targetBtn = e.target.closest('.replacement-btn');
                    document.querySelectorAll('.replacement-btn').forEach(btn => {
                        btn.querySelector('label').classList.remove('active');
                    });

                    targetBtn.querySelector('label').classList.add('active');

                    self.replacementProductId = targetBtn.dataset.idx;
                }
            });

            this.handleCloseModal = () => {
                if (this.isModalShow) {
                    this.isModalShow = false;
                    this.resetState();
                }
            };

            window.addEventListener('close-any-vue-modal', this.handleCloseModal);
        },
        beforeDestroy() {
            window.removeEventListener('close-any-vue-modal', this.handleCloseModal);
        },
    };
</script>

<style scoped>
    #easyAddressSearch h2 {
        margin-bottom: 2rem;
        font-size: 1.5rem;
        text-align: center;
    }
    .search-icon {
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='48px' height='48px'%3E%3Cpath fill-rule='evenodd' fill-opacity='0' fill='rgb(248, 248, 248)' d='M-0.000,48.000 L-0.000,-0.000 L48.000,-0.000 L48.000,48.000 L-0.000,48.000 Z'/%3E%3Cpath fill-rule='evenodd' fill='rgb(34, 34, 34)' d='M31.000,28.000 L29.420,28.000 L28.860,27.460 C30.820,25.180 32.000,22.220 32.000,19.000 C32.000,11.820 26.180,6.000 19.000,6.000 C11.820,6.000 6.000,11.820 6.000,19.000 C6.000,26.180 11.820,32.000 19.000,32.000 C22.220,32.000 25.180,30.820 27.460,28.860 L28.000,29.420 L28.000,31.000 L38.000,40.980 L40.980,38.000 L31.000,28.000 ZM19.000,28.000 C14.020,28.000 10.000,23.980 10.000,19.000 C10.000,14.020 14.020,10.000 19.000,10.000 C23.980,10.000 28.000,14.020 28.000,19.000 C28.000,23.980 23.980,28.000 19.000,28.000 Z'/%3E%3C/svg%3E");
        width: 24px;
        height: 24px;
        background-size: 24px;
        display: inline-block;
        border: none;
        background-color: transparent;
        position: absolute;
        right: 20px;
        top: 10px;
        background-repeat: no-repeat;
    }
    .input-bottom {
        border-right: none;
        border-top: none;
        border-radius: 0;
        border-left: none;
        border-bottom: 1px solid #222;
    }
    .searchClear-wrap {
        position: absolute;
        z-index: 1;
        right: 65px;
        top: 3px;
        width: 18px;
        height: 18px;
        display: inline-block;
        border: none;
        background-color: transparent;
    }
    .searchClear {
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='36px' height='36px'%3E%3Cpath fill-rule='evenodd' fill-opacity='0' fill='rgb(248, 248, 248)' d='M-0.000,36.000 L-0.000,-0.000 L36.000,-0.000 L36.000,36.000 L-0.000,36.000 Z'/%3E%3Cpath fill-rule='evenodd' fill='rgb(191, 191, 191)' d='M18.000,3.000 C9.705,3.000 3.000,9.705 3.000,18.000 C3.000,26.295 9.705,33.000 18.000,33.000 C26.295,33.000 33.000,26.295 33.000,18.000 C33.000,9.705 26.295,3.000 18.000,3.000 ZM25.500,23.385 L23.385,25.500 L18.000,20.115 L12.615,25.500 L10.500,23.385 L15.885,18.000 L10.500,12.615 L12.615,10.500 L18.000,15.885 L23.385,10.500 L25.500,12.615 L20.115,18.000 L25.500,23.385 Z'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        width: 18px;
        position: absolute;
        height: 18px;
        background-size: 18px;

    }
    .address-form {
        //margin-top: -1.25rem;
        height: 50vh;
        overflow-y: auto;
        overflow-x: hidden;
        font-size: 14px;
    }
    .address-form-list {
        height: 100%;
        //overflow-y: auto;
    }
    .address-form::-webkit-scrollbar {
        width: 2px;
        height: 6px;
    }
    .address-form::-webkit-scrollbar-thumb {
        height: 2px;
        background: #ddd;
        border-radius: 50px;
    }
    .address-form p {
        margin-bottom: 18px;
        font-size: 1rem;
    }
    .address-form-list li {
        position: relative;
        padding: 1.25rem 0;
        border-bottom: 1px solid #dbdbdb;
    }
    .address-form-list .box-btn {
        position: absolute;
        top: 1.25rem;
        right: 0;
        margin-top: 0;
    }
    .address-form-list .btn-line-point {
        display: flex;
        align-items: center;
        justify-content: center;
        width: auto;
        height: 2rem;
        padding: 0 1rem;
        font-size: 0.875rem;
        font-weight: 600;
        border-radius: 0.25rem;
        border: 1px solid #f66238;
        color: #f66238;
    }
    .address-form-list p {
        margin-bottom: 0;
        line-height: 1.4;
    }
    .address-form-list .tit {
        padding: 0.25rem 4.4rem 0 0;
        color: #191919;
        font-size: 1.125rem;
    }
    .address-form-list .zipcode {
        color: #767676;
        font-size: 1rem;
    }
    .address-form-list .doro {
        margin-top: 1rem;
        color: #777;
        font-size: 0.875rem;
    }
    .address-form-list .jibun {
        margin-top: 0.25rem;
        color: #999;
        font-size: 0.875rem;
    }
    .address-form-list-none {
        border-bottom: 1px solid #dbdbdb;
        padding: 5rem 0;
        text-align: center;
    }

    .modal-dialog {
        margin: 0.5rem;
    }
    @media (min-width: 576px) {
        .modal-dialog {
            margin: 1.75rem auto;
            max-width: 500px;
        }
    }

    .modal-body {
        height: auto;
    }
    .bt-btn {
        position: absolute;
        left: 1rem;
        bottom: 1rem;
        width: calc(100% - 2rem);
        text-align: center;
        line-height: 50px;
        background: #222;
        border-radius: 4px;
        border: none;
        z-index: 1;
    }

    .bt-btn span {
        color:#fff;
    }
    .bt-btn.disabled {
        border: 0;
        color: #767676;
        background-color: #EDEDED;
    }
    .bt-btn.disabled:hover {
        color: #767676;
        background-color: #EDEDED;
    }
    .bt-btn.disabled span {
        color: #767676;
    }
    .n-box {
        display: flex;
        margin-top: 0.5rem;
    }
    .n-icon {
        display: inline-flex;
        width: 18px;
        height: 18px;
        margin-right: 2px;
        background: url('/images/cs_order/icon-info-circle.png') no-repeat 0 0;
        background-size: 100%;
    }
    .n-text {
        color: #f83838;
        font-size: 0.875rem;
    }
    .dim-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 998;
    }

    .custom-checkbox {
        min-height: auto;
        margin-top: 1rem;
    }
    .custom-control-label::before,
    .custom-control-label::after {
        top: 0;
    }
    .box-danger {
        margin-top: 1.875rem;
        padding: 0.75rem;
        border-radius: 0.25rem;
        text-align: center;
        background: #fff6f6;
    }
    .box-danger p {
        margin: 0;
        font-size: 0.875rem;
        color: #767676;
    }
    .box-danger .tit {
        margin-bottom: 0.375rem;
        font-size: 1rem;
        color: #191919;
    }
</style>
